import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../foundation/breakpoints/values.js';
import { List, ListItem } from '../../dataDisplay/List/styled.js';

var MenuContainer = styled.div.withConfig({
  displayName: "MenuContainer",
  componentId: "sc-y0uo4i-0"
})(["display:flex;flex-direction:column;position:relative;max-height:100vh;overflow-y:auto;border-radius:", ";background-color:", ";z-index:1000;box-shadow:", ";max-height:45vh;@media ", "{position:fixed;bottom:0;left:0;right:0;max-height:unset;}"], themeGet('borderRadius.md'), themeGet('colors.gray.0'), themeGet('dropShadow.200'), breakpoints.sm);
var MenuBody = styled.div.withConfig({
  displayName: "MenuBody",
  componentId: "sc-y0uo4i-1"
})(["display:flex;flex:1;flex-direction:column;overflow:auto;"]);
var MenuList = styled(List).attrs({
  as: 'nav'
}).withConfig({
  displayName: "MenuList",
  componentId: "sc-y0uo4i-2"
})(["padding-left:", ";padding-right:", ";"], themeGet('spacing.sm'), themeGet('spacing.sm'));
var MenuItem = styled(ListItem).attrs(function (props) {
  return Object.assign({
    as: 'button',
    type: 'button'
  }, props);
}).withConfig({
  displayName: "MenuItem",
  componentId: "sc-y0uo4i-3"
})([""]);

export { MenuBody, MenuContainer, MenuItem, MenuList };
